import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle } from 'lucide-react';

export function VinMissingWarningModal({ open, onAddVin, onContinue, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="bg-[var(--theme-card)] border-[var(--theme-border)]">
        <DialogHeader>
          <div className="flex items-center gap-2 text-[#D97706]">
            <AlertTriangle className="w-5 h-5" />
            <DialogTitle className="text-[var(--theme-text-primary)]">No VIN provided</DialogTitle>
          </div>
          <DialogDescription className="text-[var(--theme-text-secondary)] pt-2">
            Your Plus listing includes a bundled PPSR check. Without a VIN, the PPSR check
            cannot be completed and this bonus will be forfeited. You can still publish the listing,
            but buyers won't see the PPSR badge.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={onContinue}
            className="border-[var(--theme-border)]"
          >
            Continue without VIN
          </Button>
          <Button
            onClick={onAddVin}
            className="bg-[#1E3A5F] hover:bg-[#2d5a8e] text-white"
          >
            Add VIN now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
